import LoginActionHandlerBase from './action_handler_base';
import {SYSTEM_EVENTS} from '../../../events/events';
import Event from '../../../utils/event';

export default class CloseActionHandler extends LoginActionHandlerBase {
    static CLASS = 'CloseActionHandler';

    actionName() {
        return 'onclose';
    }

    execute() {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_LoginPopup', action: 'CloseClick'});

        return this.serviceFactory.webLoginService().closeLoginForm();

    }
}